<template>
  <div class="pagenavi">
    <div class="pagenavi-con">
      <a class="first"
         href="javascript:;"
         @click="btnFirst_click">처음</a>
      <a class="previouspostslink"
         href="javascript:;"
         @click="btnPrev_click">이전</a>
      <template v-for="pageNo in pageNos"
                :key="pageNo">
        <a class="smaller page" href="javascript:;"
           v-if="pageNo != paging.nowPageNo"
           @click="btnPage_click(pageNo)">
          {{pageNo}}
        </a>
        <span class="current"
              v-if="pageNo == paging.nowPageNo">{{pageNo}}</span>
      </template>
      <a class="nextpostslink"
         href="javascript:;"
         @click="btnNext_click">다음</a>
      <a class="last"
         href="javascript:;"
         @click="btnLast_click">마지막</a>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, defineEmits} from 'vue';
import {getUtils} from "@/utils/import";
const {$alert} = getUtils();

const props = defineProps({
  paging: {
    type: Object,
    required: true,
  }
});

// 전체 페이지 수
const totPageNo = computed(() => {
  const {totCnt, listCnt} = props.paging;
  return Math.ceil(totCnt / listCnt);
});

const pageNos = computed(() => {
  const {pageCnt, nowPageNo} = props.paging;

  const start = Math.floor((nowPageNo - 1) / pageCnt) * pageCnt + 1;
  const end = Math.min(start + pageCnt - 1, totPageNo.value);

  const pageNos = [];
  for (let i = start; i <= end; i++) {
    pageNos.push(i);
  }

  return pageNos;
})

const emits = defineEmits(['move-page']);
const movePage = (pageNo) => {
  emits('move-page', pageNo);
}

const btnPage_click = (pageNo) => {
  movePage(pageNo)
}

const btnFirst_click = () => {
  movePage(1);
}

const btnPrev_click = async () => {
  const nowPageNo = props.paging.nowPageNo;
  if (nowPageNo == 1) {
    await $alert('처음 페이지입니다.');
    return false;
  }

  movePage(nowPageNo-1);
}

const btnNext_click = async () => {
  const nowPageNo = props.paging.nowPageNo;

  if (nowPageNo == totPageNo.value) {
    await $alert('마지막 페이지입니다.');
    return false;
  }

  movePage(nowPageNo+1);
}

const btnLast_click = () => {
  movePage(totPageNo.value);
}
</script>

<style scoped>

</style>